import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { iconButtonStyle } from '../../utils/styles';
import { effectiveZoom } from '../../utils/zoom';
import { ItemTypes, variablesIcons } from '../../constants/constants';
import { initializeGroupBoxes } from '../../utils/boxes';
import { NavbarButton } from '../Layout/NavbarButton';
import LabeledControlRow from './LabeledControlRow';

const selector = (state) => {
  const boxes = [...state.boxes, ...state.masks.map((m) => m.boxes).flat()];
  const box = boxes.find((b) => b.id === state.selectedBoxId);
  return {
    groupSelectionBoxes:
      state.groupSelection.length === 0
        ? []
        : boxes.filter((b) => state.groupSelection.includes(b.id)),
    box,
    addGroupBox: state.addGroupBox,
    ungroupBoxes: state.ungroupBoxes,
  };
};

// Grouper / dégrouper la sélection. Vivait dans la top bar (AlignmentComponent),
// où le bouton apparaissait loin de la sélection et sans libellé : il rejoint la
// section ACTIONS du panel de droite, avec le reste des actions de la box.
const BoxGroupButton = ({ showLabel = false }) => {
  const { groupSelectionBoxes, box, addGroupBox, ungroupBoxes } =
    useStore(selector);
  const { t } = useTranslation();

  const isGroupBox = box?.type === ItemTypes.GROUP_BOXES;
  // Rien à grouper sans multi-sélection, et un groupe ne se met pas dans un
  // groupe : même règle que dans la top bar.
  const isHidden =
    !box ||
    (!isGroupBox &&
      (groupSelectionBoxes.length === 0 ||
        groupSelectionBoxes.some((b) => b.type === ItemTypes.GROUP_BOXES)));

  if (isHidden) return null;

  const label = isGroupBox ? t('ungroup') : t('group');
  const groupButton = (
    <NavbarButton
      tooltipContent={label}
      onClick={() => {
        if (isGroupBox) {
          ungroupBoxes(box);
          return;
        }
        const { zoomLevel, landscape } = useStore.getState();
        const zoomFactor = effectiveZoom(zoomLevel, landscape) / 100;
        addGroupBox(
          initializeGroupBoxes([...groupSelectionBoxes, box], zoomFactor)
        );
      }}
      icon={
        isGroupBox ? (
          <FontAwesomeIcon
            icon={icon({ name: 'link-slash', style: 'light' })}
            style={iconButtonStyle()}
          />
        ) : (
          <FontAwesomeIcon
            icon={variablesIcons[ItemTypes.GROUP_BOXES]}
            style={iconButtonStyle()}
          />
        )
      }
    />
  );

  if (showLabel) return <LabeledControlRow control={groupButton} label={label} />;
  return groupButton;
};

export default BoxGroupButton;
